import { AxiosInstance } from "./client";
import { SizeGuidesApis } from "./endpoints";

export const getSizeGuides = (params) => {
  return AxiosInstance()
    .get(SizeGuidesApis.LIST_SIZE_GUIDES, { params })
    .then((response) => response?.data?.data);
};
